import { Dropdown, Menu, Icon, Modal } from 'antd';
import React, { useMemo, useState } from 'react';
import ModalTitle from '../../components/shared/ModalTitle/ModalTitle';
import DeleteWebsiteIndexEntry from '../websiteIndexEntry/DeleteWebsiteIndexEntry';
import { useFetchWebsiteIndexEntriesQuery } from '../websiteIndexEntry/service';

type Props = {
    websiteGuid: string;
};

export default function HeaderActions({ websiteGuid }: Props) {
    const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const { data: websiteIndexEntries } = useFetchWebsiteIndexEntriesQuery();

    const website = useMemo(() => websiteIndexEntries?.find((websiteIndexEntry) => websiteIndexEntry.guid === websiteGuid), [websiteGuid, websiteIndexEntries]);

    const handleDeleteDomain = async () => {
        setIsModalOpen(true);
        setIsDropdownVisible(false);
    };

    return (
        <>
            <Dropdown
                visible={isDropdownVisible}
                onVisibleChange={setIsDropdownVisible}
                trigger={['click']}
                placement="bottomLeft"
                overlay={
                    <Menu>
                        <Menu.Item
                            key="delete"
                            onClick={handleDeleteDomain}
                        >
                            <Icon type="delete" /> Remove domain
                        </Menu.Item>
                    </Menu>
                }
            >
                <Icon
                    type="more"
                    style={{ cursor: 'pointer', fontSize: '28px' }}
                />
            </Dropdown>

            <Modal
                title={
                    <ModalTitle
                        title="Remove domain:"
                        meta={website?.domain}
                    />
                }
                visible={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                destroyOnClose={true}
            >
                <DeleteWebsiteIndexEntry
                    websiteGuid={websiteGuid}
                    onFinish={() => setIsModalOpen(false)}
                />
            </Modal>
        </>
    );
}
